import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import Price from 'components/lab-order/price/price.component';
import { LabOrderContext } from 'pages/order-flow/lab-order/lab-order-context';

const OrderTotalPrice: FC = () => {
    const [price, setPrice] = useState(0);
    const { order } = useContext(LabOrderContext);

    useEffect(() => {
        let totalPrice = 0;
        order.constructions.forEach((construction) => {
            if (!construction.warranty) {
                const actionPrices = construction.actions.reduce((total, action) => {
                    const priceWithVat = action.priceWithVat || 0;
                    return total + priceWithVat;
                }, 0);
                const materialPrices = construction.materials.reduce((total, material) => {
                    const priceWithVat = material.priceWithVat || 0;
                    return total + priceWithVat;
                }, 0);
                totalPrice = totalPrice + actionPrices + materialPrices;
            }
        });
        setPrice(totalPrice);
    }, [order.constructions]);

    return (
        <Fragment>
            <Price label="TOTAL_PRICE" price={price} />
        </Fragment>
    );
};

export default OrderTotalPrice;
